import Papa from "papaparse";
import { getAllFields } from "../../../../../hooks/useTableColumnsConfig";
import parseProfileUrl from "../parseProfileUrl";

export default function parseCsvProfiles({ file }) {
  const normalizeColumnName = (name) => {
    return name.toLowerCase().trim()
      .replace(/\s+/g, '_')
      .replace(/[%]/g, '')
      .replace(/\//g, '_')
      .replace(/-/g, '_')
      .replace(/[^a-z0-9_]/g, '');
  };

  const buildLabelToDbMap = () => {
    const allFields = getAllFields();
    const map = {};
    
    allFields.forEach(field => {
      const dbColumn = field.db_column;
      const label = field.label || field.db_column.replaceAll("_", " ").replace(/\b\w/g, (c) => c.toUpperCase());
      
      map[normalizeColumnName(dbColumn)] = dbColumn;
      map[normalizeColumnName(label)] = dbColumn;
    });
    
    return map;
  };

  const createColumnMapping = (csvHeaders) => {
    const labelToDbMap = buildLabelToDbMap();
    const mapping = {};
    
    csvHeaders.forEach(header => {
      const normalized = normalizeColumnName(header);
      
      if (labelToDbMap[normalized]) {
        mapping[header] = labelToDbMap[normalized];
      } else {
        mapping[header] = normalized;
      }
    });
    
    return mapping;
  };

  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      skipEmptyLines: true,
      header: true,
      complete: (csvRaw) => {
        try {
          const linkColumnName = Object.keys(csvRaw.data[0] || {}).find(k => k.toLowerCase() === "link");
          if (!linkColumnName) {
            return reject(new Error("CSV must have a 'link' column."));
          }
          
          const csvHeaders = Object.keys(csvRaw.data[0] || {});
          const columnMapping = createColumnMapping(csvHeaders);
          
          const csvProfiles = [];
          const parseErrors = [];

          csvRaw.data.forEach((row) => {
            const rawLink = row[linkColumnName]?.trim();
            if (!rawLink) return;

            try {
              const { platform, username, link } = parseProfileUrl({ url: rawLink });
              const profile = {
                username: username.toLowerCase(),
                platform: platform.toLowerCase(),
                link,
              };
              
              Object.entries(columnMapping).forEach(([csvColumn, dbColumn]) => {
                if (csvColumn !== linkColumnName && dbColumn && row[csvColumn]) {
                  const value = row[csvColumn]?.trim();
                  if (value) {
                    profile[dbColumn] = value;
                  }
                }
              });
              
              csvProfiles.push(profile);
            } catch (e) {
              parseErrors.push({ link: rawLink, error: e.message });
            }
          });

          resolve({ csvProfiles, parseErrors });
        } catch (error) {
          reject(error);
        }
      },
      error: (err) => {
        reject(new Error("CSV error: " + err.message));
      },
    });
  });
}

